import BaseService from './../base'

class AreaService extends BaseService {
  // 根据父节点id获取当前的省市县
  async areaByParentIdApi (parentId) {
    return await this.get(`/area/${parentId}`);
  }
}

export default new AreaService()
